import { render, staticRenderFns } from "./statistics-chart.vue?vue&type=template&id=396a3274&"
import script from "./statistics-chart.vue?vue&type=script&lang=js&"
export * from "./statistics-chart.vue?vue&type=script&lang=js&"
import style0 from "./statistics-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports